<template>
  <div v-if="returnReasonCategories.length > 0" style="clear:both;" class="order_line_return_reason_wrapper">
    <div v-for="category in returnReasonCategories" :key="category.id">
      <div style="width:33%;float:left;padding-bottom:12px;">
        <div style="width:20%;float:left;">
          <label>{{ category.name }} </label>
        </div>
        <div style="width:80%;float:left;">
          <div v-for="returnReason in category.returnReasons" :key="returnReason.id">
            <el-checkbox
              v-model="returnReason.checked"
              :disabled="readonly"
              @change="handleCheckboxChange(returnReason, $event)"
            />
            {{ returnReason.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentReturnReasonID: Number,
    readonly: Boolean
  },
  data() {
    return {
      returnReasonCategories: [],
      checkedReason: null
    };
  },
  watch: {
    currentReturnReasonID() {
      this.setCurrentReturnReason(this.currentReturnReasonID);
    }
  },
  async created() {
    await this.$store.dispatch('returnReasonCategory/getItems');
    this.returnReasonCategories = await this.$store.getters['returnReasonCategory/loadedItems'];
    if (this.currentReturnReasonID) {
      this.setCurrentReturnReason(this.currentReturnReasonID);
    }
  },
  methods: {
    handleCheckboxChange(returnReason) {
      if (this.checkedReason && this.checkedReason.returnReasonID !== returnReason.returnReasonID) {
        this.checkedReason.checked = false;
      }
      this.checkedReason = returnReason;
      this.$emit('action', 'childValue', returnReason.returnReasonID);
    },
    setCurrentReturnReason(id) {
      this.returnReasonCategories.some(c => {
        const currentReturnReason = c.returnReasons.find(r => r.returnReasonID === id);
        if (currentReturnReason) {
          currentReturnReason.checked = true;
          this.checkedReason = currentReturnReason;
          this.$forceUpdate();
          return true;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.order_line_return_reason_wrapper {
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #c0aa98 !important;
  }
}
</style>
